import { render, staticRenderFns } from "./portfolioA.vue?vue&type=template&id=30db5658"
import script from "./portfolioA.vue?vue&type=script&lang=js"
export * from "./portfolioA.vue?vue&type=script&lang=js"
import style0 from "./portfolioA.vue?vue&type=style&index=0&id=30db5658&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports